// Події шляху клієнта для рекламного трекера.
// Шлемо на наш бекенд (він знає клієнта за JWT і підписує запит до трекера) —
// секрет трекера у фронтенд не потрапляє. Помилки аналітики ігноруємо.
import api from "./api/api";

const newEventId = () =>
  window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;

export const cartLines = (items) => items.map((i) => ({ id: i.id, quantity: i.quantity }));

export const trackEvent = (eventName, data = {}) => {
  // Лише для клієнтів, що увійшли через Telegram — інакше подію ні до кого прив'язати
  if (!localStorage.getItem("access")) return;
  api
    .post("/analytics/events/", { event_name: eventName, event_id: newEventId(), ...data })
    .catch(() => {});
};

// Відкриття магазину — один раз на завантаження Mini App (StrictMode подвоює ефекти)
let shopOpenSent = false;
export const trackShopOpen = () => {
  if (shopOpenSent) return;
  shopOpenSent = true;
  trackEvent("MiniAppOpen");
};
